export interface LanguageOption {
  code: string;
  name: string;
}

export const Languages: Record<string, LanguageOption> = {
  ENGLISH: { code: 'en', name: 'English' },
  SPANISH: { code: 'es', name: 'Spanish' },
  GERMAN: { code: 'de', name: 'German' },
  ITALIAN: { code: 'it', name: 'Italian' },
  FRENCH: { code: 'fr', name: 'French' },
  DUTCH: { code: 'nl', name: 'Dutch' },
  PORTUGUESE: { code: 'pt', name: 'Portuguese' }
} as const;

export type LanguageCode = (typeof Languages)[keyof typeof Languages]['code'];
export const LANGUAGE_OPTIONS: LanguageOption[] = Object.values(Languages);

export interface CaptionLanguageSelectionDialogProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly onConfirm: (language: LanguageOption) => void;
  readonly availableLanguages: LanguageOption[];
  readonly translatedLanguages: LanguageOption[];
  readonly originalLanguage: LanguageOption[];
  readonly onLanguageSelection: (language: string) => void;
}
